const themeDir = '/wp-content/themes/easysend-2.0';

export const ApiUrl = {
    currencyPairs: '/calculator/currencies/%countryIn%/%countryOut%',
    directions: '/calculator/all-countries',
    exchangeRate: '/v2/transfers/exchange_rate',
    deliveryMethods: '/v2/public/offers/%countryIn%/%currencyIn%/%countryOut%/%currencyOut%/%amount%',
    agentsPoints: '/public/agents',
    agentsMapSettings: '/wp-json/api/v1/agents-map',
    socialAvailability: '/wp-json/api/v1/profiles/social/is-available',
    signIn: `${themeDir}/api/token.php`,
    signInSn: `${themeDir}/api/social.php`,
    signUp: `${themeDir}/api/register.php`,
    signUpBusiness: `${themeDir}/api/registerBusiness.php`,
};
